import * as React from 'react';
import { format } from 'date-fns';
import { Prompt } from 'react-router';
import { reduxForm } from 'redux-form';
import { Row, Col } from 'react-flexbox-grid';
import { compose, withProps, withHandlers } from 'recompose';

import * as storage from '@inqool/uas-web-core/es/utils/storage';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { getEmployee, changePassword } from '@modules/employees/_employeesActions';
import { InputField, Input } from '@components/form';
import { withNotifications } from '@components/hoc/withNotifications';
import { required, validateAdminPasswordPolicy, validatePasswordConfirm, validatePasswordPolicy } from '@utils/validators';
import { administrationPermission } from '../../../permissions';

const isLoggedUserAdmin = () => {
  const permissions = storage.get('permissions');

  if (!permissions) {
    return false;
  }

  try {
    return JSON.parse(permissions).includes(administrationPermission);
  } catch (err) {
    return false;
  }
};

const enhance = compose<any, any>(
  withProps(() => {
    return {
      item: storage.get('id'),
      passwordPolicyValidator: isLoggedUserAdmin() ? validateAdminPasswordPolicy : validatePasswordPolicy
    };
  }),
  withNotifications({ changePassword }),
  entityDetailEnhancer<any, any>({
    getEntity: getEmployee,
    defaultEntity: {}
  }),
  withProps<{}, any>(({ entity }) => ({
    initialValues: {
      ...entity
    },
    maxYear: format(new Date(), 'YYYY')
  })),
  withHandlers({
    onSubmit: ({ closeItem, changePasswordNotify }) => async formData => {
      const response = await changePasswordNotify(formData);

      if (response) {
        closeItem();
      }
    }
  }),
  reduxForm({
    form: 'edit-profile-form',
    validate: validatePasswordConfirm
  })
);

const View: React.SFC<any> = props => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Row>
        <Col md={12}>
          <h4>Úpravy profilu uživatele</h4>
        </Col>
        <Col md={12}>
          <InputField
            component={Input}
            type={'password'}
            name="password"
            label="Heslo *"
            validate={[required, props.passwordPolicyValidator]}
          />
        </Col>
        <Col md={12}>
          <InputField
            component={Input}
            type={'password'}
            name="passwordConfirm"
            label="Heslo znovu *"
            validate={[required, props.passwordPolicyValidator]}
          />
        </Col>
      </Row>
      <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 ' }} />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={props.closeItem} />
    </form>
  </div>
);

export const EditProfileModal = enhance(View);



// WEBPACK FOOTER //
// ./src/components/sidebar/userProfiles/EditProfileModal.tsx